import styled from "styled-components";
import { COLORS, responsive } from "../../../../../styles/constants.style";

export const BulkTransferSearchParticipantsWrapper = styled.div`
  .MuiPickersTextField-root,
  .MuiPickersInputBase-root {
    width: 100%;
  }

  .form-container {
    ${responsive.MOBILE`
        padding: 0px 8px;
      `}
  }

  .button-container {
    margin: 32px 16px 16px 20px;
    text-align: end;
    ${responsive.MOBILE`
        margin: 16px 8px 16px 8px;
    `}
    button {
      ${responsive.MOBILE`
        width:100%;
        
      `}
    }
  }

  .search-header-container {
    display: flex;
    justify-content: space-between;

    .reset-all-button {
      padding: 0px 10px;
      height: 40px;

      svg {
        margin-right: 8px;
      }
    }
  }

  .transfer-accordion {
    .MuiAccordionSummary-expandIconWrapper {
      display: none;
    }
  }

  .transfer-type-container {
    padding: 24px 16px;

    ${responsive.MOBILE`
      padding: 16px 8px;
     `}

    .MuiRadioGroup-root {
      padding-left: 14px;
    }
  }

  .accordion-header-result {
    .accordion-title {
      display: flex;
      align-items: center;
    }
  }

  .selected-count {
    color: ${COLORS.cirrus_white};
    background-color: ${COLORS.cirrus_black7};
    padding: 2px 9px 2px 9px;
    border-radius: 7px;
  }

  .semi-header {
    display: flex;
    padding: 16px 16px 16px 16px;
    justify-content: flex-end;
  }
`;
